import { createFileRoute } from '@tanstack/react-router';
import { ConnectionsPage } from '../../features/connections';

export const Route = createFileRoute('/portal/connections/')({ component: ConnectionsPage });
